import React, { Component } from 'react'
import PropTypes from 'prop-types'
import OnboardingListItem from './OnboardingListItem'
import NewInvitationForm from './StudentInvitationForm'
import CopyInviteLinkCard from './CopyInviteLinkCard'

/**
 * @class InvitedPersonsWrapper
 * @description Container for displaying, searching, and creating new Invitations (Student or Otherwise)
 */
class InvitedPersonsWrapper extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    data: PropTypes.any.isRequired,
    error: PropTypes.string,
    insToken: PropTypes.string,
    onInviteStudent: PropTypes.func.isRequired,
    onResendInvite: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      showInviteStudentForm: false,
      showCopyInviteLink: false,
    }

    this.setShowInviteStudentForm = () => {
      this.setState({ showInviteStudentForm: !this.state.showInviteStudentForm })
    }

    this.setShowCopyInviteLink = () => {
      this.setState({ showCopyInviteLink: !this.state.showCopyInviteLink })
    }

    this.onInvitePerson = () => {
      this.props.onInviteStudent()
        .then(() => this.setShowInviteStudentForm())
        .catch(() => {})
    }
  }

  /**
   * @method render
   */
  render() {
    const {
      data,
      error,
      insToken,
      onResendInvite,
    } = this.props

    const { showCopyInviteLink, showInviteStudentForm } = this.state

    return (
      <div>
        {!showInviteStudentForm && !showCopyInviteLink &&
          <div style={{ position: 'relative' }}>
            <button
              style={{position: 'absolute', right: 0, top: -42, fontSize: 15, paddingRight: 0}}
              className="btn btn-link"
              onClick={() => this.setShowCopyInviteLink()}
            >
              Get Invite Link
            </button>
            {!!data.length ?
              <div>
                <div className="card invite-list"
                     style={{boxShadow: (data.length > 3 ? '0px -10px 10px -10px #000 inset' : 'none')}}
                >
                  {data.map(item => (
                    <OnboardingListItem
                      key={item._id}
                      id={item._id}
                      content={item.inviteeEmail}
                      onAction={onResendInvite}
                      actionTitle="resend"
                    />))}
                </div>
                < button className = "btn btn-block btn-primary" onClick={() => this.setShowInviteStudentForm()}>
                  Invite Students
                </button>
              </div>
              :
              <div style={{margin: '20px 0', textAlign: 'center'}}>
                <button className="btn btn-primary" onClick={() => this.setShowInviteStudentForm()}>
                Invite Students
                </button>
              </div>
            }
          </div>
        }
        {showInviteStudentForm &&
          <div>
            <NewInvitationForm onSubmit={this.onInvitePerson} onClose={this.setShowInviteStudentForm}/>
            <h6 className="text-danger">{error}</h6>
          </div>
        }
        {showCopyInviteLink &&
          <div>
            <CopyInviteLinkCard insToken={insToken} onClose={this.setShowCopyInviteLink}/>
          </div>
        }
      </div>
    )
  }
}

export default InvitedPersonsWrapper



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/InvitedPersonsWrapper.js